$border: 1px solid;
$box-shadow-hover: inset 0px 0px 0px 2px;
$line-height: 24px;
$option-min-height: 44px;

:host {
  display: block;
  width: 100%;

  * {
    box-sizing: border-box;
  }
}

.#{$prefix}dropdown-option {
  position: relative;
  width: 100%;
  min-height: $option-min-height;
  padding: 11px 13px 12px 13px;
  padding-left: var(--textPaddingLeft, 13px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  @include eon-typography();
  line-height: $line-height;
  -webkit-appearance: none;
  box-shadow: inset 0 -1px 0 0 v(borderBottomColor);
  background-color: v(backgroundColor);
  outline: none;
  cursor: pointer;
  @include noneUserSelect();

  eon-ui-checkbox {
    align-self: flex-start;
  }

  &:hover {
    border: none;
    background-color: v(backgroundColorHover);
    text-decoration: underline;
  }

  &.#{$prefix}focus {
    border: none;
    background-color: v(backgroundColorHover);
    text-decoration: underline;
  }

  &.#{$prefix}selected {
    background-color: v(backgroundColorActive);
    box-shadow: unset;
  }

  &.#{$prefix}multiselect {
    &:hover {
      text-decoration: none;
      background-color: v(backgroundColorHover) !important;
    }

    &.#{$prefix}focus {
      text-decoration: none;
      background-color: v(backgroundColorHover) !important;
    }

    &.#{$prefix}selected {
      background-color: inherit;
      box-shadow: inset 0 -1px 0 0 v(borderBottomColor);
    }
  }
}
